
const InitAdminApiPages = () => {
    $("#auto-display-message-modal").modal('show');
}

export default InitAdminApiPages;